module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "reach-info"
  }, [_c('tr', [_c('td', {
    staticClass: "number potential"
  }, [_vm._v(_vm._s(_vm.$t('fn.number', {
    value: _vm.maxReach
  })))]), _c('td', [_vm._v(_vm._s(_vm.$t('pos.offer.potentital-total')))])]), _c('tr', [_c('td', {
    staticClass: "number guaranteed"
  }, [_vm._v(_vm._s(_vm.$t('fn.number', {
    value: _vm.minReach
  })))]), _c('td', [_vm._v(_vm._s(_vm.$t('pos.offer.guaranteed')))])]), _c('tr', [_c('td', {
    staticClass: "number not-reached"
  }, [_vm._v(_vm._s(_vm.$t('fn.number', {
    value: _vm.maxReach - _vm.minReach
  })))]), _c('td', [_vm._v(_vm._s(_vm.$t('pos.offer.not-reached')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acfc6982"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-offer/ReachInfo.vue
// module id = 957
// module chunks = 1